









import { defineComponent } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import { usePdpStore, ComponentsInNavigation } from '@/store/pdp'

import { useMobile } from '@/composables/ui/useMobile'
import { smoothScroll } from '~/common/utils/smoothScroll'

export default defineComponent({
  emits: ['onClickNavItem'],
  setup(_, { emit }) {
    const { isMobile } = useMobile()
    const pdpStore = usePdpStore()
    const { activeComponentInNavigation, renderedComponents } = storeToRefs(pdpStore)

    let scrollEndedTimeout: ReturnType<typeof setTimeout> | undefined

    const setActive = (component: ComponentsInNavigation) => {
      if (scrollEndedTimeout) {
        // clear timeout to make sure that the `isScrolling` flag is not set to false
        // during the following scrolling
        clearTimeout(scrollEndedTimeout)
        scrollEndedTimeout = undefined
      }

      pdpStore.isScrolling = false
      pdpStore.setActiveComponentInNavigation(component.ANCHOR)
      pdpStore.isScrolling = true /* set this flag to indicate that following calls to
                                     `setActiveComponentInNavigation` were generated because of the
                                     smooth scrolling and they should be not shown in navigation list */
      smoothScroll(`#${component.ANCHOR}`)
      scrollEndedTimeout = setTimeout(() => {
        // `scrollIntoView` doesn't have any mechanism that scrolling was finished
        // use timeout to approximate that scrolling was finished
        pdpStore.isScrolling = false
        scrollEndedTimeout = undefined
      }, 1000)

      emit('onClickNavItem')
    }

    return {
      isMobile,
      activeComponentInNavigation,
      renderedComponents,
      setActive,
    }
  },
})
